import {
    deleteAsmlComponentDetails, fetchAsmlComponentDetails,
    fetchAsmlComponentStatusDetails,
    setAsmlComponentDetails,
    updateAsmlComponentDetails, updateAsmlComponentMac, updateAsmlComponentMonitoringDetails
} from "../network/AsmlDeviceOverviewNetworkAPI";
import {getTimestampNow} from "../../../util/Util";
import {INDUCT_CAMERA_SUB_ASSET_TYPE} from "../../../util/Constants";

export const InductCameraDeviceOverviewReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false, timestamp: getTimestampNow()}
        case "LOAD_VIEW":
            fetchAsmlComponentDetails(action.data.dispatcher, INDUCT_CAMERA_SUB_ASSET_TYPE)
            return state
        case "LOAD_STATUS":
            fetchAsmlComponentStatusDetails(action.data.dispatcher, state)
            return state
        case "ADD_DEVICE_DATA":
            setAsmlComponentDetails(action.data.dispatcher, action.data.stateValues, INDUCT_CAMERA_SUB_ASSET_TYPE)
            return state
        case "UPDATE_DEVICE_DATA":
            updateAsmlComponentDetails(action.data.dispatcher, action.data.stateValues, INDUCT_CAMERA_SUB_ASSET_TYPE)
            return state
        case "DELETE_DEVICE_DATA":
            deleteAsmlComponentDetails(action.data.dispatcher, action.data.mac)
            return state
        case "UPDATE_DEVICE_MAC":
            updateAsmlComponentMac(action.data.dispatcher, action.data.stateValues, action.data.mac, INDUCT_CAMERA_SUB_ASSET_TYPE)
            return state
        case "UPDATE_MONITORING_DATA":
            updateAsmlComponentMonitoringDetails(action.data.dispatcher, action.data.stateValues, action.data.mac, INDUCT_CAMERA_SUB_ASSET_TYPE)
            return state
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/reducer/InductCameraDeviceOverviewReducer.js